<!--会议拒绝查询组件-->
<template>
  <div class="cardtable">
    <v-flex xs12>
      <div class="event-filter">
        <v-flex xs12>
          <v-layout row>
            <v-flex xs10>
              <div class="event-title">{{ this.$t('audit.filter') }}</div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout row>
          <v-flex xs12 md3>
            <div class="event-filter-title">
              {{ this.$t('audit.event') }}
            </div>
          </v-flex>
          <v-flex xs12 md3>
            <div class="event-filter-title">
              {{ this.$t('audit.operator') }}
            </div>
          </v-flex>
          <v-flex xs12 md3>
            <div class="event-filter-title">
              {{ this.$t('audit.content') }}
            </div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3>
            <v-select
              class="filter-interval event-filter-content"
              :items="category"
              v-model="filter.event"
            >
            </v-select>
          </v-flex>
          <v-flex xs3>
            <v-text-field
              required
              class="filter-interval event-filter-content"
              v-model="filter.actorName"
              :value="filter.actorName"
            ></v-text-field>
          </v-flex>

          <v-flex xs3>
            <v-text-field
              required
              class="filter-interval event-filter-content"
              v-model="filter.context"
              :value="filter.context"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md3>
            <div class="event-filter-title">
              {{ this.$t('audit.operatedate') }}
            </div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md6>
            <v-layout row>
              <v-flex xs12 md5.5>
                <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                  class="filter-interval event-filter-content"
                >
                  <v-text-field
                    readonly
                    slot="activator"
                    v-model="filter.startDate"
                    append-icon="mdi-grid"
                    class="event-filter-content"
                  ></v-text-field>
                  <v-date-picker
                    v-model="filter.startDate"
                    no-title
                    style="color:black!important"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xsl2 md1>
                ~
              </v-flex>
              <v-flex xs12 md5.5>
                <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                  class="filter-interval event-filter-content"
                >
                  <v-text-field
                    readonly
                    slot="activator"
                    v-model="filter.endDate"
                    append-icon="mdi-grid"
                    class="event-filter-content"
                  ></v-text-field>
                  <v-date-picker
                    v-model="filter.endDate"
                    no-title
                    style="color:black!important"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs1>
            <v-btn
              @click="clearfilter()"
              color="#1cade4"
              class="Btn_add"
              depressed
            >
              {{ this.$t('audit.clearfilter') }}</v-btn
            >
          </v-flex>
          <v-flex xs1>
            <v-btn
              depressed
              color="#1cade4"
              class="Btn_add"
              @click="getsearchdata()"
            >
              {{ this.$t('audit.apply') }}</v-btn
            >
          </v-flex>
          <v-flex xs1>
            <v-btn
              @click="logexport()"
              color="#1cade4"
              class="Btn_add"
              depressed
            >
              {{ this.$t('common.export') }}</v-btn
            >
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <v-flex xs12 style="background-color:white!important;">
      <div class="allevent-content">
        <div class="table-header">
          <v-layout row>
            <v-flex xs12 md1>
              <span>{{ this.$t('audit.operatedate') }}</span>
            </v-flex>
            <v-flex xs12 md1>
              <span>{{ this.$t('audit.operator') }}</span>
            </v-flex>
            <v-flex xs12 md1>
              <span>{{ this.$t('audit.event') }}</span>
            </v-flex>
            <v-flex xs12 md3>
              <span>{{ this.$t('audit.content') }}</span>
            </v-flex>
            <v-flex xs12 md3>
              <span>{{ this.$t('audit.oldvalue') }}</span>
            </v-flex>
            <v-flex xs12 md3>
              <span>{{ this.$t('audit.newvalue') }}</span>
            </v-flex>
          </v-layout>
        </div>
        <div class="table-row" v-for="(item, key) in audit.items" :key="key">
          <v-layout row>
            <v-flex xs12 md1>
              <div class=" table-cell">
                {{ item.actionDate }}
              </div>
            </v-flex>
            <v-flex xs12 md1>
              <div class=" table-cell">
                {{ item.actorName }}
              </div>
            </v-flex>
            <v-flex xs12 md1>
              <div class=" table-cell">
                {{ item.event }}
              </div>
            </v-flex>
            <v-flex xs12 md3>
              <div class=" table-cell">
                {{ item.context }}
                <a
                  target="_blank"
                  :href="item.url"
                  v-if="item.url != '' && item.url != null"
                  >查看图片</a
                >
              </div>
            </v-flex>
            <v-flex xs12 md6>
              <div>
                <code-diff
                  :old-string="item.oldValue"
                  :new-string="item.newValue"
                  outputFormat="side-by-side"
                  :context="10"
                >
                </code-diff>
              </div>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="audit.items.length == 0" class="partipant-module-MESSAGE">
          {{ this.$t('emptymsg') }}
        </div>
        <v-pagination
          v-model="page"
          :length="length"
          :total-visible="7"
        ></v-pagination>
      </div>
    </v-flex>
    <core-dataloading ref="dataload"></core-dataloading>
    <core-confirm ref="myConfirm"></core-confirm>
  </div>
</template>
<style>
.content-padding {
  margin-right: 10px;
}
</style>
<script>
import { mapState } from 'vuex'
import CoreDataloading from '@/components/core/dataloading.vue'
import CoreConfirm from '@/components/core/confirm.vue'
import { logQuery, logexport, logList } from '@/request/api'
import CodeDiff from 'vue-code-diff'
export default {
  components: {
    CoreDataloading,
    CoreConfirm,
    CodeDiff
  },
  data: () => ({
    filter: {
      actorName: null,
      event: 0,
      context: null,
      startDate: null,
      endDate: null
    },
    length: 0,
    page: 1,
    pagesize: 8,
    menu1: null,
    category: []
  }),
  mounted: function() {
    this.$nextTick(() => {
      this.getdatas()
      this.logtype()
    })
    this.base.confirmDialog = this.$refs.myConfirm
  },
  watch: {
    page() {
      this.getdatas()
    },
    pagesize() {
      this.getdatas()
    }
  },
  computed: {
    ...mapState({
      audit: state => state.audit,
      base: state => state.base
    })
  },
  methods: {
    getsearchdata() {
      this.page = 1
      this.getdatas()
    },
    getdatas() {
      var _this = this
      let param = {
        startDate: _this.filter.startDate,
        endDate: _this.filter.endDate,
        actorName: _this.filter.actorName,
        event: _this.filter.event,
        context: _this.filter.context,
        pageIndex: this.page,
        pageSize: this.pagesize,
        t: new Date().getTime()
      }
      this.base.eventdom
        .CommonEventApi(
          logQuery,
          param,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在查询数据'
        )
        .then(res => {
          _this.length =
            res.totalCount % _this.pagesize == 0
              ? res.totalCount / _this.pagesize
              : parseInt(res.totalCount / _this.pagesize) + 1
          var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/i
          res.items.forEach(item => {
            item.url = ''
            if (item.oldValue == null) {
              item.oldValue = ''
            }
            if (item.newValue == null) {
              item.newValue = ''
            }
            if (this.isJSON(item.oldValue)) {
              let obj = JSON.parse(item.oldValue)
              item.oldValue = JSON.stringify(obj, null, 4)
            }
            if (this.isJSON(item.newValue)) {
              let obj = JSON.parse(item.newValue, null, 4)
              item.newValue = JSON.stringify(obj, null, 4)
            }

            if (item.context != null && item.context != '') {
              let urls = item.context.match(exp)
              if (urls != null && urls.length > 0) {
                item.url = urls[0]
              }

              // item.context = item.context.replace(exp,"<a href='$1'>$1</a>");
            }
          })
          _this.audit.items = res.items
        })
    },
    isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str)
          if (typeof obj == 'object' && obj) {
            return true
          } else {
            return false
          }
        } catch (e) {
          return false
        }
      }
    },
    logexport() {
      this.base.eventdom
        .CommonEventApi(
          logexport,
          this.filter,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在导出数据'
        )
        .then(data => {
          let blob = new Blob([data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          let currentdate = new Date()
          let file_name = 'Log' + currentdate.getTime()
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE

            window.navigator.msSaveOrOpenBlob(blob, file_name + '.xlsx')
          } else {
            let link = document.createElement('a')
            link.download = file_name
            link.href = window.URL.createObjectURL(blob)
            link.click()
            //释放内存
            window.URL.revokeObjectURL(link.href)
          }
        })
    },
    logtype() {
      var _this = this
      this.base.eventdom
        .CommonEventApi(logList, null, null, null, null)
        .then(res => {
          var items = []
          for (var i = 0; i < res.length; i++) {
            var item = {}
            item.text = res[i].name
            item.value = res[i].id
            items.push(item)
          }
          _this.category = items
        })
    },
    clearfilter() {
      this.filter = {
        actorName: null,
        event: 0,
        context: null,
        startDate: null,
        endDate: null
      }
    }
  }
}
</script>
